import { useNavigate } from 'react-router';
import { ManageAccounts } from '@mui/icons-material';
import {
    Avatar,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    IconButton,
    Stack,
    TextField,
    Typography,
} from '@mui/material';

import { Business } from '@barboxx/models';
import { getInitials } from '@barboxx/utils';

interface Props {
    business: Business.DetailsResponse;
}

export function PlaceInfo({ business }: Props) {
    const { employees, place } = business;
    const { id, streetAddress, city, state, zip, name, phoneNumber } = place;
    const address = `${streetAddress} ${city}, ${state} ${zip}`;
    const navigate = useNavigate();

    return (
        <Card>
            <CardHeader title={name} />
            <CardContent>
                <Stack direction="row" gap={2}>
                    <Stack flex={1} gap={2} direction="column">
                        <TextField label="Address" disabled value={address} />
                        <TextField
                            label="Business Phone"
                            disabled
                            value={phoneNumber ?? ''}
                        />
                    </Stack>
                    <Stack flex={1}>
                        <Typography variant="h6">Contacts</Typography>
                        <Stack>
                            {employees
                                ?.filter(e =>
                                    e.roles?.some(r =>
                                        ['Owner', 'Manager'].includes(r)
                                    )
                                )
                                .map(e => {
                                    const fullName = `${e.firstName} ${e.lastName}`;
                                    return (
                                        <CardHeader
                                            key={e.id}
                                            avatar={
                                                <Avatar
                                                    sx={{
                                                        width: 48,
                                                        height: 48,
                                                    }}
                                                    aria-label={fullName}
                                                    alt={fullName}
                                                    src={e?.avatar || ''}
                                                >
                                                    {getInitials(e)}
                                                </Avatar>
                                            }
                                            action={
                                                <IconButton
                                                    aria-label="manage-account"
                                                    onClick={() => {
                                                        navigate(
                                                            `/users/${e.id}`
                                                        );
                                                    }}
                                                >
                                                    <ManageAccounts />
                                                </IconButton>
                                            }
                                            title={fullName}
                                            subheader={e.phoneNumber}
                                        />
                                    );
                                })}
                        </Stack>
                    </Stack>
                </Stack>
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end' }}>
                <Button color="primary" variant="text" href={`/places/${id}`}>
                    Edit
                </Button>
            </CardActions>
        </Card>
    );
}
